import React from "react";

export default function CreateButton(props){
    return(
        <>
            <a role="button" className="green text-decoration-none pr-lg-2 pr-md-2 pr-sm-0 d-sm-none d-lg-block d-md-block d-none"
               onClick={props.handleAnnouncementCreate}>
                <span className='large-font font-bold'>Create New</span>
            </a>
            <a role="button" className="green text-decoration-none pr-lg-2 pr-md-2 pr-sm-0 d-sm-block d-lg-none d-md-none"
               onClick={props.handleAnnouncementCreate}>
                <span
                    className='fs-sm-4 font-bold'
                    style={{fontSize:'16px'}}
                >Create New</span>
            </a>
        </>
)
}
